import React from 'react'
import {
    Grid,
    Typography,
    Container,
    Avatar
} from '@material-ui/core'
import { Images } from 'salvatores'
import {
    ArrowBack,
    CameraAlt
} from '@material-ui/icons'
import { CustomAppBar, CustomButton } from '../../../shared'
import { PWIDX1, PWIDX2, PWIDX3, PWIDT1, PWIDT2, PWIDT3, PWIDFaceFrame, PWIDIDFrame } from '../../../assets/images'
import { getContent } from '../../../utils/helper'
import { supportedLanguageMapping } from '../../language/constants'

const IDPhoto = ({ goBack, goToScreen, language, languageJSON, captureImage, step, idPhotoImage, 
    submit, handleChange, isCameraOn }) => {
    return (
        <div>
            <CustomAppBar title={getContent(languageJSON, 'title_photoid')}
                leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
                rightButton={<CustomButton variant="text" color="primary" handleChange={() => goToScreen('language', { to: 'idPhoto' })} label={supportedLanguageMapping[language]} />} />
            {step === 1 ?
                <Container style={{ padding: 0 }}>
                    <Grid container justify="center" alignItems="center" spacing={2} style={{ padding: '2% 0%', maxHeight: '100vh', overflow: 'scroll', paddingBottom: 130 }}>
                        <Grid item xs={11} style={{ backgroundColor: '#FEF1F1', padding: '4%' }}>
                            <Typography variant="body1">
                                {getContent(languageJSON, 'subtitle_incorrect_ways')}
                            </Typography>
                            <Grid container justify="center" spacing={2} style={{ marginTop: '2%' }}>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '13vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PWIDX1} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'option_photoid_incorrect_focus')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '13vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PWIDX2} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'option_photoid_incorrect_cover')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '13vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PWIDX3} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'option_photoid_incorrect_phone')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={11} style={{ backgroundColor: '#F2FEF1', padding: '4%' }}>
                            <Typography variant="body1">
                                {getContent(languageJSON, 'subtitle_correct_ways')}
                        </Typography>
                            <Grid container justify="center" spacing={2} style={{ marginTop: '2%' }}>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '13vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PWIDT1} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'option_photoid_correct_focus')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '13vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PWIDT2} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'option_photoid_correct_cover')}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Avatar variant="square" style={{ width: '100%', height: '13vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PWIDT3} />
                                    <Typography style={{ textAlign: 'center', fontSize: 10, backgroundColor: '#fff' }}>{getContent(languageJSON, 'option_photoid_correct_position')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
                : null}
            {step === 2 ?
                <Container>
                    <Grid container justify="center" spacing={4} style={{ maxHeight: '100vh', overflow: 'scroll', paddingBottom: 130 }}>
                        <Grid item xs={11}>
                            <Avatar variant="square" src={idPhotoImage} style={{ width: '100%', height: '50vh', objectFit: 'contain' }} />
                            <div style={{ margin: '5%' }}>
                                <Images
                                    frameHeight={400}
                                    frame={PWIDFaceFrame}
                                    subFrame={PWIDIDFrame}
                                    title={getContent(languageJSON, 'action_retake_photoid')}
                                    constraints={{
                                        audio: false,
                                        video: {
                                            facingMode: "user"
                                        }
                                    }}
                                    cameraStateChange={() => {}}
                                    content={
                                        <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="secondary" 
                                            label={<Grid container alignItems="center" justify="center">
                                                <CameraAlt style={{ marginRight: 5 }} />
                                                <Typography style={{ fontSize: 12 }}>{getContent(languageJSON, 'action_retake_photoid')}</Typography>
                                            </Grid>} />
                                    }
                                    captureImage={captureImage} />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
                : null}
            {step === 1 ?
                <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: !isCameraOn ? 'absolute' : '', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
                    <Grid item xs={11}>
                        <Images
                            frameHeight={320}
                            frame={PWIDFaceFrame}
                            subFrame={PWIDIDFrame}
                            title={getContent(languageJSON, 'title_photoid')}
                            constraints={{
                                audio: false,
                                video: {
                                    facingMode: "user"
                                }
                            }}
                            cameraStateChange={(value) => handleChange('isCameraOn', value)}
                            content={
                                <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', textTransform: 'none' }} color="primary" 
                                    label={<Grid container alignItems="center" justify="center">
                                        <CameraAlt style={{ marginRight: 5 }} />
                                        <Typography variant="button">{getContent(languageJSON, 'action_capture_photoid')}</Typography>
                                    </Grid>} />
                            }
                            captureImage={captureImage} />
                    </Grid>
                </Grid> : <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: 'absolute', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
                    <Grid item xs={11}>
                        <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', textTransform: 'none', fontSize: 12 }} color="primary" 
                            label={<Typography variant="button">{getContent(languageJSON, 'action_submit_photoid')}</Typography>} handleChange={submit} />
                    </Grid>
                </Grid>}
        </div >
    )
}

export default IDPhoto